import * as styles from "./Heading3.scss";
import { SimpleComponent } from "./SimpleComponent";

export class Heading3 extends SimpleComponent {
    protected className = styles.heading3;
    protected tag = "h3";
}
